import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { InfiniteScrollCustomEvent, ModalController } from '@ionic/angular';
import { AirportListService } from 'src/app/services/airport/airport-list.service';
import { Subscription } from 'rxjs';
import { Airline } from 'src/app/models/airline';
export interface Item {
  text: string;
  value: string;
}
@Component({
  selector: 'airlines-modal',
  templateUrl: './airlines-modal.component.html',
  styleUrls: ['./airlines-modal.component.scss'],
})
export class AirlinesModalComponent implements OnInit {
  // tslint:disable-next-line: max-line-length
  @Input() type: string;
  @Input() airlinesData: Airline[];

  public airlineList: any[];
  public selectedAirlines: Airline[];
  public noData: number;
  public page: number;
  public count: number;
  public searchTerm: string;
  public currentCount: number;
  private airlineSubscription: Subscription;
  private homeAirportExist: boolean;

  constructor(
    private airportListService: AirportListService,
    private modalController: ModalController
  ) {
    this.noData = 0;
    this.airlineList = [];
    this.selectedAirlines = [];
    this.homeAirportExist = this.airportListService.getSelectedAirport()
      ? true
      : false;
  }

  ngOnInit() {
    this.page = 10;
    this.count = 20;
    this.currentCount = 20;
    this.searchTerm = '';
    this.getAirlines();
    this.selectedAirlines = this.airlinesData;
  }

  getAirlines() {
    this.airportListService
      .getAllAirlines(this.searchTerm, this.page, this.count)
      .subscribe((resData) => {
        const receivedAirLineList = resData?.result || [];
        if (receivedAirLineList && receivedAirLineList.length > 0) {
          this.currentCount = receivedAirLineList.length;
          if (this.airlinesData.length > 0) {
            const diffAirlineList = receivedAirLineList.filter(
              (obj1: any) =>
                !this.airlinesData.some(
                  (obj2) => obj1.airportCode === obj2.airlineCode
                )
            );
            const modifiedAirlinesData = this.airlinesData.map((airline) => {
              const { airlineName, airlineCode, ...rest } = airline;
              return {
                airportName: airlineName,
                airportCode: airlineCode,
                ...rest,
              };
            });
            this.airlineList = [...modifiedAirlinesData, ...diffAirlineList];
          } else {
            this.airlineList = receivedAirLineList;
          }
        } else {
          this.noData = 1;
        }
      });
  }

  ionViewDidLeave() {
    this.airlineSubscription?.unsubscribe();
  }

  filterAirlineList(event) {
    // tslint:disable-next-line: prefer-const
    this.searchTerm = event.srcElement.value;
    if (this.searchTerm.length > 1) {
      this.airlineList = [];
      this.noData = 0;
      this.page = 1;
      this.count = 20;
      this.getAirlines();
    }
  }

  filterAirlineListOnEnter(event) {
    // tslint:disable-next-line: prefer-const
    this.searchTerm = event.srcElement.value;
    if (this.searchTerm.length > 1) {
      this.airlineList = [];
      this.noData = 0;
      this.page = 1;
      this.count = 20;
      this.getAirlines();
    }
  }

  cancelChanges() {
    this.modalController.dismiss();
  }

  confirmChanges() {
    this.modalController.dismiss(this.selectedAirlines);
  }

  isChecked(value) {
    return this.selectedAirlines.find(
      (item) => item?.airlineName === value?.airportName
    );
  }

  checkboxChange(ev) {
    const { checked, value } = ev.detail;
    if (checked === true) {
      this.selectedAirlines = [
        ...this.selectedAirlines,
        { airlineName: value.airportName, airlineCode: value.airportCode },
      ];
    }
    if (checked === false) {
      const index = this.selectedAirlines
        .map((item) => item.airlineName)
        .indexOf(value.airportName);
      this.selectedAirlines.splice(index, 1);
    }
  }

  getNextPage(event) {
    if (this.currentCount < this.count) {
      (event as InfiniteScrollCustomEvent).target.complete();
      return;
    }
    this.page++;
    this.airportListService
      .getAllAirlines(this.searchTerm, this.page, this.count)
      .subscribe((resData) => {
        const receivedAirLineList = resData?.result || [];
        if (receivedAirLineList && receivedAirLineList.length > 0) {
          this.currentCount = receivedAirLineList.length;
          if (this.airlinesData?.length > 0) {
            const diffAirlineList = receivedAirLineList.filter(
              (obj1: any) =>
                !this.airlinesData.some(
                  (obj2) => obj1.airportCode === obj2.airlineCode
                )
            );
            this.airlineList = [...this.airlineList, ...diffAirlineList];
          } else {
            this.airlineList = [...this.airlineList, ...receivedAirLineList];
          }
        } else {
          this.noData = 1;
        }
        (event as InfiniteScrollCustomEvent).target.complete();
        if (this.currentCount < this.count) {
          event.target.disabled = true;
        } else {
          event.target.disabled = false;
        }
      });
  }
}
